import { useMemo, useRef } from 'react'

export interface LongPressOptions {
  onLongPress: (pos: { x: number; y: number }) => void
  delay?: number
}

export function useLongPress({ onLongPress, delay = 500 }: LongPressOptions) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)
  const pos = useRef<{ x: number; y: number } | null>(null)

  const handlers = useMemo(
    () => ({
      onTouchStart: (e: React.TouchEvent) => {
        const touch = e.touches[0]
        pos.current = { x: touch.clientX, y: touch.clientY }
        timer.current = setTimeout(() => {
          if (pos.current) onLongPress(pos.current)
        }, delay)
      },
      onTouchMove: () => {
        if (timer.current) {
          clearTimeout(timer.current)
          timer.current = null
        }
      },
      onTouchEnd: () => {
        if (timer.current) {
          clearTimeout(timer.current)
          timer.current = null
        }
      },
    }),
    [onLongPress, delay],
  )

  return handlers
}
